import { EDIT_LISTING_OTHER_THINGS,
         CLOSE_LISTING_OTHER_THINGS,
         PENDING_SUBMIT_LISTING_OTHER_THINGS,
         COMPLETE_SUBMIT_LISTING_OTHER_THINGS,
         FAILED_SUBMIT_LISTING_OTHER_THINGS
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyotherthingsediting: false
}


const mlListingOtherThings = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_OTHER_THINGS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyotherthingsediting: true
        }

        case CLOSE_LISTING_OTHER_THINGS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyotherthingsediting: false
        }

        case PENDING_SUBMIT_LISTING_OTHER_THINGS: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_OTHER_THINGS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_OTHER_THINGS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingOtherThings